import { Button } from "@mui/material";

export default function DeleteSaleUI({ selectedSales, onDelete }) {
  return (
    <Button
      variant="contained"
      color="error"
      onClick={onDelete}
      disabled={selectedSales.length === 0}
      sx={{
        mt: 2,
        width: "16%",
        height: "7.6vh",
        ml: 1,
        fontSize: { md: "12px", sm: "10px" },
      }}
    >
      Eliminar: {selectedSales.length}
    </Button>
  );
}
